import { render } from "./mispadres_ingles.vue?vue&type=template&id=3a757354&scoped=true"
const script = {}

import "./mispadres_ingles.vue?vue&type=style&index=0&id=3a757354&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a757354"]])

export default __exports__